<template>
  <a-dropdown
    class="fl"
    :overlay-style="{'z-index': 1052}"
  >
    <a
      class="ant-dropdown-link"
      href="javascript:;"
    >
      <span class="truename-text">{{ baseinfo.truename }}
        <i
          v-if="stationMessageCount"
          class="circle"
        /></span>
      <i class="iconfont iconicon-test19 arrow-icon" />
    </a>
    <a-menu slot="overlay">
      <template v-if="routeName !== 'AccountInfo' && routeName !== 'OrgIndex'">
        <a-menu-item
          v-if="!$isDingDing"
          class="to-org-link"
        >
          <a href="/organization/index">
            {{ $t('message[1965]') }}
            <!-- 切换组织 -->
          </a>
          <p>{{ comName || baseinfo.comname }}</p>
        </a-menu-item>
        <a-menu-item>
          <a href="/account/accountinfo">{{ $t('message["365"]') }}</a>
        </a-menu-item>
      </template>
      <a-menu-item>
        <a
          href="/account/maillist"
        >
          <span class="mail-text">{{ $t('message["1885"]') }}<i
            v-if="stationMessageCount"
            class="circle"
          /></span>
        </a>
      </a-menu-item>
      <a-menu-item>
        <a
          class="language-change"
          href="javascript:;"
          @click="changeLanguage"
        >
          {{ langTxt.langTit }}
          <i>{{ langTxt.langIcon }}</i>
        </a>
      </a-menu-item>
      <a-menu-item>
        <a
          href="https://help.westartrack.com/"
          target="_blank"
        >
          <!-- 帮助中心 -->
          {{ $t('message["1966"]') }}
        </a>
      </a-menu-item>
      <a-menu-item
        v-if="!$isDingDing"
        class="login-out-btn"
      >
        <a
          href="javascript:;"
          @click="logout"
        >{{ $t('message["1236"]') }}</a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { clearAuth, getLang, clearPid, clearStorage } from '@/lib/storage'
import store from '@/store'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('organization/org', ['comName']),
    stationMessageCount () {
      let { stationMessageCount } = this.baseinfo
      return stationMessageCount
    },
    lang () {
      return getLang()
    },
    langTxt () {
      const { lang } = this
      const isZh = lang === 'zh'
      return {
        langTit: isZh ? 'English' : '简体中文',
        langIcon: isZh ? 'EN' : 'CN'
      }
    },
    routeName () {
      return this.$route.name
    }
  },

  methods: {
    ...mapActions('organization/org', ['fetchOrgDetail']),
    changeLanguage (type) {
      this.$getLanguage()
    },
    logout () {
      clearAuth()
      clearPid()
      store.commit('setAuth', '')
      this.$store.commit('setRealbackAuth', '')
      clearStorage('realbackAuth')
      clearStorage('realbackCid')
      this.$router.replace({ name: 'AccountLogin' })
    }
  }
}
</script>

<style scoped lang="scss">
.mail-text, .truename-text {
  position: relative;
  .circle {
    position: absolute;
    top: -2px;
    right: -10px;
    width: 6px;
    height: 6px;
    border-radius: 4px;
    background-color: #f57676;
  }
}
.truename-text .circle {
  top: -0px;
  right: -2px;
}
.to-org-link {
  border-bottom: 1px solid #ebebeb;
  margin: 0 !important;
  padding: 5px 20px !important ;
  a:hover{
    background:#F4F7F9 ;
  }
  p{
    color: #b3b3b3;
    font-size: 12px;
    line-height: 20px;
    padding: 8px 0 4px;
  }
}
.to-org-link:hover{
  background: none !important;
}
.login-out-btn {
  a {
    color: #f57676 !important;
  }
}
</style>
